import React from "react"
import { Link } from "react-router-dom"


const Footer: React.FC = () => {
  return (
    <footer className="bg-primary text-white px-4 sm:px-6 md:px-8 py-8 md:py-12">
      <div className="max-w-7xl mx-auto grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 border-b border-white/20 pb-8 md:pb-10">
        <div>
          <h2 className="text-base md:text-lg font-semibold mb-2">Bioskar Solutions</h2>
          <p className="text-xs md:text-sm text-white/80">Building smarter systems for emerging markets.</p>
        </div>
        <div>
          <h2 className="text-base md:text-lg font-semibold mb-2">Solutions</h2>
          <ul className="space-y-1 text-xs md:text-sm text-white/80">
            <li>
              <Link to="/services" className="hover:text-white transition-colors">
                Workflow Platforms
              </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:text-white transition-colors">
                Smart Infrastructure
              </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:text-white transition-colors">
                System Integration
              </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:text-white transition-colors">
                Custom Software
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <h2 className="text-base md:text-lg font-semibold mb-2">Company</h2>
          <ul className="space-y-1 text-xs md:text-sm text-white/80">
            <li>
              <Link to="/about" className="hover:text-white transition-colors">
                About Us
              </Link>
            </li>
            <li>
              <Link to="/services" className="hover:text-white transition-colors">
                Services
              </Link>
            </li>
            <li>
              <Link to="/industries" className="hover:text-white transition-colors">
                Industries
              </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:text-white transition-colors">
                Contact
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <h2 className="text-base md:text-lg font-semibold mb-2">Resources</h2>
          <ul className="space-y-1 text-xs md:text-sm text-white/80">
            {/* <li>
              <Link to="/resources/blogs" className="hover:text-white transition-colors">
                Blog
              </Link>
            </li> */}
                <li>
              <Link to="/resources/faqs" className="hover:text-white transition-colors">
                FAQs
              </Link>
            </li>
                  {/* <li>
              <Link to="/resources/guides" className="hover:text-white transition-colors">
                Guides & Tutorials
              </Link>
            </li> */}
                  <li>
              <Link to="/resources/partnership" className="hover:text-white transition-colors">
                Partnership & Info
              </Link>
            </li>
       
        
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto mt-4 md:mt-6 flex flex-col md:flex-row justify-between items-center text-xs md:text-sm text-white/80">
        <p>© 2025 Bioskar Solutions. All rights reserved.</p>
        <div className="flex flex-wrap justify-center md:justify-end gap-4 md:space-x-4 mt-3 md:mt-0">
          <Link to="/privacy-policy" className="hover:text-white transition-colors">
            Privacy Policy and Terms of Service
          </Link>
      
      
        </div>
      </div>
    </footer>
  )
}

export default React.memo(Footer)
